module.exports = __webpack_public_path__ + "next.png?a064a99de7edddafd97cab8ef2348784";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/next.png
// module id = 63
// module chunks = 0